import "./SingleLayoutComponent.scss";
import template from "./SingleLayoutComponent.html";
import {IComponentOptions} from "angular";

export const SingleLayout = "tfSingleLayout";

export function singleLayout(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: SingleLayoutController
    };
}

export class SingleLayoutController {
}
